// Baja al disco el CSV que el motor devuelve dentro de la respuesta.

/** `RSK-10_2026-06-17.csv` — el código del reporte y el día de la corrida, en ISO para que ordene. */
export function csvFilename(reportId: string | null, createdAt: number, jobId = 'reporte'): string {
    const day = new Date(createdAt).toISOString().slice(0, 10);
    return `${reportId ?? jobId}_${day}.csv`;
}

/** Entrega el archivo al navegador; devuelve `false` con un CSV vacío, que no se baja. */
export function downloadCsv(csv: string, filename: string): boolean {
    if (!csv) return false;

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    const objectUrl = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    // Revoke diferido: Firefox y Safari cancelan la descarga si el blob se libera antes de leerlo.
    setTimeout(() => {
        URL.revokeObjectURL(objectUrl);
    }, 0);
    return true;
}
